import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { CirclesContainer, LINE_POSITIONS, Spinner } from '../Spinner/index.js';

const LoadingCirclesContainer = styled(CirclesContainer) `
  margin: auto;
`;
const LoadingSpinner = () => {
    return (jsx(LoadingCirclesContainer, Object.assign({ "data-testid": 'loading-spinner' }, { children: LINE_POSITIONS.map(linePosition => (jsx(Spinner, { linePosition: linePosition }, linePosition))) })));
};

export { LoadingSpinner as default };
//# sourceMappingURL=LoadingSpinner.js.map
